export default __webpack_public_path__ + "static/media/ht-rt-it.ada1057b.svg";